



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { DepartmentManager } from '@/models/admin/department';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { dealService, departmentService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class BlockOptionsListPage extends Base {
  public pagedBlockLineItems: any[] = [];
  public headers: VHeaders[] = [];
  public pagination = new PaginationModel('name');
  public loading: boolean = false;
  public storeId: number = 0;
  public actions: any[] = [];

  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('departments.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.deleteLineItem();
    },
  };
  public blockId: string = '';
  public lineItemsToDelete: any = {
    id: '',
    storeId: 0,
    key: '',
    value: '',
    recordType: '',
    optionsId: '',
  };

  public preventPaginationCall: boolean = false;

  public setHeaders() {
    this.headers = [
      {
        text: 'key',
        align: 'left',
        value: 'key',
        sortable: true,
      },
      {
        text: 'Record Type',
        align: 'left',
        value: 'recordType',
        sortable: true,
      },
      {
        text: 'Sequence Number',
        align: 'left',
        value: 'sequenceNumber',
        sortable: true,
      },
      {
        text: 'Action',
        isNotDataProp: true,
        align: 'center',
        sortable: false,
      },
    ];
  }

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'departments.managerGridHeaders.gridAction.delete'
        ) as string,
        color: 'error',
        action: (model: any, storeId: string) => {
          this.confirmDelete(model);
        },
      },
    ];
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.dealaccounts.dealrecap',
        params: { storeId: this.storeId.toString() },
      });
    }
    if (methodName === 'addBlockOptions') {
      this.$router.push({
        name: 'admin.dealaccounts.dealrecap.blocks.add',
        params: { id: this.blockId },
      });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('departments.btnBack'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('departments.btnBack'),
        click: 'backToList',
        icon: 'fas fa-arrow-left',
      });
    }
    buttons.push({
      id: '1',
      type: 'button',
      title: 'Add Block Options',
      disabled: false,
      visible: true,
      class: 'btn',
      label: 'Add Block Options',
      click: 'addBlockOptions',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.setHeaders();
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    } else {
      this.storeId = Number(this.userSession.storeId);
    }
    if (this.$route.params.id) {
      this.blockId = this.$route.params.id;
      this.getLineItems();
    }

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setActions();
  }
  public async getLineItems(): Promise<void> {
    try {
      this.loading = true;
      const managers = await dealService.getDealBlockLineItems(
        this.blockId,
        Number(this.storeId),
        this.pagination
      );
      this.pagedBlockLineItems = managers.results;
      this.pagination.totalItems = managers.total;
    } finally {
      this.loading = false;
    }
  }
  public updatePaging(paging: any) {
    this.pagination = paging;
  }
  public confirmDelete(item: any): void {
    this.deleteDialog.model = true;
    this.lineItemsToDelete = item;
  }
  public async deleteLineItem(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await dealService.deleteBlockLineItemsAsync(
        this.blockId,
        this.lineItemsToDelete.id,
        this.storeId
      );
      this.preventPaginationCall = true;
      this.showAlert(true, 'Line Item Deleted Successfully');
      this.getLineItems();
    } finally {
      this.deleteDialog.model = false;
      this.deleteDialog.loading = false;
    }
  }
}
